import produce from 'immer';
import { atom } from 'recoil';
import reducerSelector from '../utils/reducerSelector';

export const LOADING_LIST_DRIVER = 'LOADING_LIST_DRIVER';
export const LOADED_LIST_DRIVER = 'LOADED_LIST_DRIVER';
export const REMOVE_DRIVER_SUCCESS = 'REMOVE_DRIVER_SUCCESS';
export const ADD_DRIVER_SUCCESS = 'ADD_DRIVER_SUCCESS';
export const APPROVE_DRIVER_SUCCESS = 'APPROVE_DRIVER_SUCCESS';

export const initialState = {
  page: 0,
  size: 20,
  items: [],
  order_by: 'id',
  desc: true,
  total: 0,
  isListing: false,
};
export const driverAtom = atom({
  key: 'driverState',
  default: {
    page: 0,
    size: 20,
    items: [],
    order_by: 'id',
    desc: true,
    total: 0,
    isListing: false,
  },
});
export const driverReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case LOADING_LIST_DRIVER: {
        draft.isListing = true;
        break;
      }
      case LOADED_LIST_DRIVER: {
        draft.isListing = false;
        Object.entries(action.data).forEach(([k, v]) => {
          draft[k] = v;
        });

        Object.entries(action.params).forEach(([k, v]) => {
          draft[k] = v;
        });
        break;
      }
      case REMOVE_DRIVER_SUCCESS: {
        draft.items = state.items.filter((driver) => driver.id !== action.payload);
        draft.total -= 1;
        break;
      }
      case ADD_DRIVER_SUCCESS: {
        draft.items = [action.payload, ...state.items];
        draft.total += action.totalAdded;
        break;
      }
      case APPROVE_DRIVER_SUCCESS: {
        const driverId = action.payload;
        const { items } = state;
        const targetIndex = items.findIndex((item) => item.id === parseInt(driverId, 10));
        if (targetIndex > -1) {
          draft.items[targetIndex].status = 'BACKGROUND_APPROVED';
          draft.items[targetIndex].background_status = 'MANUAL_APPROVED';
        }
        break;
      }
      default:
        throw new Error();
    }
  });
export const driverSelector = reducerSelector({
  selectorKey: 'driverSelector',
  reducer: driverReducer,
  selectorAtom: driverAtom,
});

export const existedDriversState = atom({
  key: 'existed_drivers_state',
  default: [],
});
